import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
interface RowContextMenuProps{
    rowIndex: number,
    updateIndex: (index: number, delta: number)=>void,
    duplicateRow: (index: number)=>void,
    deleteRow: (index: number)=>void,
    editMode: boolean

}
const RowContextMenu = (props: RowContextMenuProps)=> {
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownopen] = useState(false);
  const backgroundaRef = useRef<HTMLDivElement>(null);
  
  return (
    <div className="dropdown">
        
        <span onClick={e=>setDropdownopen(!dropdownOpen)}>
            <span><i className="bi bi-three-dots-vertical"></i></span>
        </span>
        {dropdownOpen && <>
            <div ref={backgroundaRef}
                style={{display: "block", opacity: "1", backgroundColor:"#00000000" ,width: "100%", height: "100%", position: "fixed", top: "0", left: "0"}} 
                tabIndex={-1} role="dialog" aria-hidden="true" 
                onClick={e=>{
                    if(e.target === backgroundaRef.current)
                    {
                        setDropdownopen(false)
                    }
                }}>
            </div>
            <ul className="dropdown-menu show" style={{right: 0}}>
                <li className="dropdown-item" role="button" onClick={e=>{props.updateIndex(props.rowIndex, -1); setDropdownopen(false);}}>
                    <span><i className="bi bi-caret-up"></i>&nbsp;{t("table-context-moveup")}</span>
                </li>
                <li className="dropdown-item" role="button" onClick={e=>{props.updateIndex(props.rowIndex, +1); setDropdownopen(false);}}>
                    <span><i className="bi bi-caret-down"></i>&nbsp;{t("table-context-movedown")}</span>
                    </li>
                {props.editMode &&
                    <li className="dropdown-item" role="button" onClick={e=>{props.duplicateRow(props.rowIndex); setDropdownopen(false);}}>
                        <span><i className="bi bi-copy"></i>&nbsp;{t("table-context-duplicate")}</span>
                        </li>
                }
                {props.editMode &&
                    <li className="dropdown-item" role="button" onClick={e=>{props.deleteRow(props.rowIndex); setDropdownopen(false);}}>
                        <span><i className="bi bi-trash3"></i>&nbsp;{t("table-context-delete")}</span>
                    </li>
                }
            </ul>
        </>}
    </div>
  );
};

export default RowContextMenu